import { Search, Heart } from "lucide-react";
import { Input } from "@/components/ui/input";

interface GroupSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export const GroupSearch = ({ searchQuery, onSearchChange }: GroupSearchProps) => {
  return (
    <div className="relative max-w-2xl mx-auto">
      <div className="relative">
        <Heart className="absolute left-4 top-1/2 transform -translate-y-1/2 text-purple-400 w-5 h-5" />
        <Input
          type="text"
          placeholder="Find your support community... try 'anxiety', 'motivation', or 'friendship'"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-12 pr-4 py-4 text-lg bg-white/90 dark:bg-gray-800/90 border-2 border-purple-200 dark:border-purple-700 rounded-2xl shadow-lg focus:border-purple-400 dark:focus:border-purple-500 focus:ring-4 focus:ring-purple-100 dark:focus:ring-purple-900/50 transition-all duration-200"
        />
      </div>
      <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-2">
        ✨ Search by topic, community name, or what kind of support you're looking for
      </p>
    </div>
  );
};